import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Super admin',
  [ManagerRole.Admin]: 'Admin',
  [ManagerRole.SalesManager]: 'Verkaufsleiter',
  [ManagerRole.SalesLeadership]: 'Vertriebsführung',
  [ManagerRole.ContentManager]: 'Inhaltlicher Leiter',
  [ManagerRole.OnboardingManager]: 'Onboarding-Manager',
  [ManagerRole.OccAgent]: 'Call-Center-Agent',
};
